import { render, staticRenderFns } from "./BottomBannerComponent.vue?vue&type=template&id=3cba85b3"
import script from "./BottomBannerComponent.vue?vue&type=script&lang=js"
export * from "./BottomBannerComponent.vue?vue&type=script&lang=js"
import style0 from "./BottomBannerComponent.vue?vue&type=style&index=0&id=3cba85b3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports